import { Link } from "react-router-dom";

const ArrowRight = () => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        aria-hidden
        className="shrink-0"
    >
        <path
            d="M2 7.5h10.5M8.5 3.5l4 4-4 4"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
    </svg>
);

const ArrowExternal = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        aria-hidden
        className="shrink-0"
    >
        <path
            d="M3.5 10.5 10.5 3.5M5 3.5h5.5V9"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// Consistent pill button used across the whole site.
// All variants share the same height, padding, radius and font size.
const BASE =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3.5 text-[14.5px] leading-none tracking-wide transition-colors duration-500 focus-visible:outline-2";

const VARIANTS = {
    // On sand/light backgrounds
    primary:
        "bg-[var(--hds-clay)] hover:bg-[var(--hds-clay-dark)] text-[var(--hds-card)] shadow-[0_12px_36px_rgba(192,112,63,0.22)]",
    secondary:
        "border border-[var(--hds-green)] text-[var(--hds-green)] hover:bg-[var(--hds-green)] hover:text-[var(--hds-card)] bg-transparent",
    // On terracotta (clay) blocks
    onClayPrimary:
        "bg-[var(--hds-card)] text-[var(--hds-clay-dark)] hover:bg-white",
    onClaySecondary:
        "border border-[var(--hds-card)]/60 text-[var(--hds-card)] hover:bg-[var(--hds-card)]/10 bg-transparent",
};

const ICONS = {
    arrow: <ArrowRight />,
    external: <ArrowExternal />,
    none: null,
};

export default function Button({
    children,
    variant = "primary",
    icon = "none",
    to,
    href,
    className = "",
    ...props
}) {
    const classes = `${BASE} ${VARIANTS[variant] || VARIANTS.primary} ${className}`;
    const content = (
        <>
            <span>{children}</span>
            {ICONS[icon]}
        </>
    );

    if (to) {
        return (
            <Link to={to} className={classes} {...props}>
                {content}
            </Link>
        );
    }
    if (href) {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={classes}
                {...props}
            >
                {content}
            </a>
        );
    }
    return (
        <button type="button" className={classes} {...props}>
            {content}
        </button>
    );
}
